import { insightArticles } from '@/mocks/insights';
import { Link } from 'react-router-dom';

export default function InsightsHero() {
  const featured = insightArticles.find((a) => a.featured);
  if (!featured) return null;

  return (
    <section className="relative pt-28 md:pt-36 pb-0 bg-[#fafaf8]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.25em] uppercase mb-3">
              Insights · 專欄文章
            </p>
            <h1
              className="font-bold text-[#1a1a1a] leading-[1.25]"
              style={{ fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)' }}
            >
              商業空間的知識與觀點
            </h1>
          </div>
          <p className="text-[#7a7a7a] text-sm max-w-sm leading-relaxed">
            來自設計師、策略顧問與專案團隊的第一手洞察，
            幫你在每一個關鍵決策前，多一分把握。
          </p>
        </div>

        {/* Featured Article */}
        <Link
          to={`/insights/${featured.id}`}
          className="group relative flex flex-col lg:flex-row rounded-2xl overflow-hidden bg-[#1a1a1a] cursor-pointer"
        >
          {/* Image */}
          <div className="lg:w-7/12 h-[300px] md:h-[420px] lg:h-[500px] overflow-hidden flex-shrink-0">
            <img
              src={featured.coverImg}
              alt={featured.title}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 lg:hidden bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
          </div>

          {/* Content */}
          <div className="lg:w-5/12 flex flex-col justify-center p-8 md:p-10 lg:p-14">
            <div className="flex items-center gap-3 mb-6">
              <span className="px-3 py-1 bg-[#b8956a] text-white text-xs font-medium rounded-full">
                精選文章
              </span>
              <span className="text-white/40 text-xs">{featured.readTime}閱讀</span>
            </div>

            <h2
              className="font-bold text-white leading-[1.35] mb-4 group-hover:text-[#d4b896] transition-colors"
              style={{ fontSize: 'clamp(1.25rem, 2vw, 1.75rem)' }}
            >
              {featured.title}
            </h2>
            <p className="text-white/55 text-sm leading-[1.85] mb-8">
              {featured.excerpt}
            </p>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mb-8">
              {featured.tags.map((tag) => (
                <span key={tag} className="px-2.5 py-1 bg-white/10 text-white/60 text-xs rounded-full">
                  #{tag}
                </span>
              ))}
            </div>

            {/* Author */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                  <img src={featured.authorAvatar} alt={featured.author} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-white text-sm font-medium">{featured.author}</p>
                  <p className="text-white/40 text-xs">{featured.authorRole}</p>
                </div>
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/50 group-hover:bg-[#b8956a] group-hover:border-[#b8956a] group-hover:text-white transition-all duration-300">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
